import type { BattleEvent } from "./types.js";

/** FNV-1a 32-bit over the compact event stream; identical inputs must give identical hashes on server and client. */
export function hashEvents(events: readonly BattleEvent[]): string {
  let h = 0x811c9dc5;
  const mix = (s: string) => {
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 0x01000193);
    }
  };
  for (const e of events) {
    mix(`${e.t}:${e.k}:${e.a ?? ""}:${e.b ?? ""}:${e.v ?? ""}:${e.x ?? ""}|`);
    if (e.detail) mix(JSON.stringify(e.detail));
  }
  return (h >>> 0).toString(16).padStart(8, "0");
}
